const BuilderItemHeader = (sortSel, setSortSel) => {
  return (label) => {
    const isSel = sortSel.label === label;
    return {
      label,
      isSel,
      onClick: () => {
        if (label === "") {
          return;
        }
        const isAsc = isSel ? !sortSel.isAsc : true;
        setSortSel({label, isAsc})
      }
    }
  }
}

export default BuilderItemHeader;
